import apiClient from './apiClient.ts';

export interface UserProfileStats {
  total_uploads: number;
  member_since: string;
  uploads_this_month: number;
  uploads_per_month_avg: number;
}

export interface FeaturedTune {
  id: number;
  youtube_id: string;
  video_title: string;
}

export interface UserProfile {
  user_id: string;
  display_name: string | null;
  bio: string | null;
  email: string;
  show_email: boolean;
  featured_tune: FeaturedTune | null;
  stats: UserProfileStats;
  is_current_user: boolean;
}

export interface UpdateProfilePayload {
  display_name?: string | null;
  bio?: string | null;
  show_email: boolean;
  featured_tune_youtube_id?: string | null;
}

export interface UserTune {
  id: number;
  youtube_id: string;
  video_title: string;
  upload_date: string | null;
}

export interface UserTunesResponse {
  tunes: UserTune[];
}

export const getUserProfile = async (userId: string): Promise<UserProfile> => {
  const response = await apiClient.get(`/user-profile/${userId}`);
  return response.data.data;
};

export const getMyProfile = async (): Promise<UserProfile> => {
  const response = await apiClient.get('/user-profile/me');
  return response.data.data;
};

export const updateMyProfile = async (payload: UpdateProfilePayload): Promise<UserProfile> => {
  const response = await apiClient.put('/user-profile/me', payload);
  return response.data.data;
};

export const getMyTunes = async (): Promise<UserTunesResponse> => {
  const response = await apiClient.get('/user-profile/me/tunes');
  return response.data.data;
};
